import React from "react";

const SimRow = ({ children, className = "" }) => {
  return (
    <>
      <div className={`row ${className}`}>{children}</div>
    </>
  );
};

export default SimRow;
